import { FC } from 'react';

type Props = {
	isCollapsed?: boolean;
};

export const Collapsible: FC<Props> = ({ children, isCollapsed }) => (
	<div className={`collapsible ${isCollapsed ? 'collapsible--collapsed' : ''}`}>{children}</div>
);
